<template>
  <div style="height:400px;">
    <div class="title">
    </div>
    <div class="content" style="width: 100%;height: 100%;">
      <!-- <EchartColumnar
        v-if="isShow"
        :key="'htzttj1'"
        :chart-id="'htzttj1'"
        :color="['#4ecb73', '#1E90FF']"
        :is-open-transverse="['category','value']"
        :multiple-y-unit="true"
        :is-legend="true"
        :x-chart-num="2"
        :x-data="xdata"
        :y-data="ydata"
        :x-type-name="xTypeName"
        :left="'50'"
        :right="'80'"
        :top="'8%'"
        :title="title"
        :legend-align="{ location:'bottom', align:'0' }"
      /> -->
      <EchartAnnular
        v-if="isShow"
        :chart-id="'ahtlxtj'"
        :alldata="allData"
        :radius="['0', '60%']"
        :color="colorArr"
        :is-label="true"
        :is-label-line="true"
        :is-legend="true"
        :legend-left="'center'"
        :legend-top="'bottom'"
        :legend-icon="'rect'"
        :legend-orient="'horizontal'"
        :text-color="'#fff'"
        :label-line-height="30"
        :label-line-length="{ length1: 10, length2: 10 } "
        :align-to="alignTo"
        :label-align="'outside'"
      />
    </div>
  </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            chartKey: 9900,
            isShow: false,
            isLoad: true,
            yunit: {},
            xdata: [],
            ydata: [
            ],
            title: '',
            xTypeName: [
            ],
            allData: []

        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        // this.getData()
        this.$bus.on('searchFn', this.getData)
    },
    beforeDestroy() {
        this.$bus.off('searchFn', this.getData)
    },
    mounted() {

    },
    methods: {
        // 获取数据
        getData(year, type) {
            console.log('year', year, type)
            let urlchange = 'pieChart'
            if (type == 1) {
                urlchange = 'pieChart'
            } else if (type == 2) {
                urlchange = 'pieChartWithType'
            } else if (type == 3) {
                urlchange = 'pieChartByZbfzr'
            }

            this.isShow = false
            this.$http({
                method: 'get',
                url: '/zbgl/zbxmlx/' + urlchange,
                params: {
                    year: year
                }
            }).then(res => {
                if (res.code === 'success') {
                    // console.log('res', res)
                    this.allData = res.body.vo

                    this.isShow = true
                }
            })
        }

    }
}
</script>

<style scoped lang="scss">

</style>
